// extracted by mini-css-extract-plugin
export var icon = "_3r-3";
export var subtitle = "_3r-2";
export var title = "_3r-1";
export var value = "_3r-0";